import React from 'react';

// Create a context with no initial values.
export const AppConfigContext = React.createContext();

export default AppConfigContext;
